app.service('article',function(main, front, articlesListView, articlesCategory, articleView, articleVotes, rankingView, authorView, authorListView, broker, ajaxPage){
	let isInit = false;
	function init(){
		switch (front.page()) {
			case 'articles-list':
			case 'news-list':
				articlesListView.init();
				break;
			case 'articles-category':
				articlesCategory.init();
				break;
			case 'article':
				if($('#single-ranking').length){
					rankingView.init();
				} else {
					articleView.init();
				}
				if(!front.katalog) {
					articleVotes.init();
				}
				break;
			case 'author':
				authorView.init();
				break;
			case 'authors':
				authorListView.init();
				break;
		}
		ajaxRefresh();
	}
	function ajaxRefresh() {
		if(isInit) {
			return;
		}
		$('body').on('click', 'a.js-article-ajax, div.js-article-ajax a:not([href^="#"])', function(event){
			event.preventDefault();
			ajaxPage.load({
				url: $(this).attr('href'),
				beforeLoad: function(){
					$.scrollTo($('#breadcrumb'));
				}
			});
		});
		isInit = true;
	};

	broker.on('PAGE_CHANGE', function() {
		init();
	});

	main.onLoad(init);
});
